import { URLs } from '../config'
import http from './http'
import { objectToFormdata } from './common'

export const service = {
    get: {

    },
    post: {
        // @Url /v1/settings/service/contract
        contract: async(params) => {
            let formdata = objectToFormdata(params)
            return await http.post(
                `${URLs.settings}/service/contract`, formdata
            )
        }
    },
    delete: {

    }
}

export const setting = {
    get: {
        // @Url /v1/settings/{cbidx}/customer
        customer: async(params) => {
            return await http.get(
                `${URLs.settings}/${params.cbidx}/customer`, {
                    params: params
                }
            )
        },
        // @Url /v1/settings/{cbidx}/logo
        logo: async(params) => {
            return await http.get(
                `${URLs.settings}/${params.cbidx}/logo`, {
                    params: params
                }
            )
        },
        // @Url /v1/settings/{cbidx}/map-list
        mapList: async(params) => {
            return await http.get(
                `${URLs.settings}/${params.cbidx}/map-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/customers/office-seal/{cbidx}
        officeSeal: async(params) => {
            return await http.get(
                `${URLs.customer}/office-seal/${params.cbidx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/customers/{cbidx}/operation-rule
        operationRule: async(params) => {
            return await http.get(
                `${URLs.customer}/${params.cbidx}/operation-rule`, {
                    params: params
                }
            )
        },
        // @Url /v1/settings/{cbidx}/car
        car: async(params) => {
            return await http.get(
                `${URLs.settings}/${params.cbidx}/car`, {
                    params: params
                }
            )
        },
        // @Url /v1/settings/{cbidx}/car-disinfect-print
        carDisinfectPrint: async(params) => {
            return await http.get(
                `${URLs.settings}/${params.cbidx}/car-disinfect-print`, {
                    params: params
                }
            )
        },
        // @Url /v1/settings/{cbidx}/car/{idx}/maintain
        maintain: async(params) => {
            return await http.get(
                `${URLs.settings}/${params.cbidx}/car/${params.idx}/maintain`, {
                    params: params
                }
            )
        },
        // @Url /v1/settings/{cbidx}/car/{idx}/operation/select
        operation: async(params) => {
            return await http.get(
                `${URLs.settings}/${params.cbidx}/car/${params.idx}/operation/select`, {
                    params: params
                }
            )
        },
        // @Url /v1/settings/{cbidx}/insurance
        insurance: async(params) => {
            return await http.get(
                `${URLs.settings}/${params.cbidx}/insurance`, {
                    params: params
                }
            )
        },
        // @Url /v1/settings/{cbidx}/insurance/list
        insuranceList: async(params) => {
            return await http.get(
                `${URLs.settings}/${params.cbidx}/insurance/list`, {
                    params: params
                }
            )
        },
        // @Url /v1/permission/groups/{cbidx}
        groups: async(params) => {
            return await http.get(
                `${URLs.permission}/groups/${params.cbidx}`, {
                    params: params
                }
            )
        },
        // /v1/settings/{cbidx}/salary
        salary: async(params) => {
            return await http.get(
                `${URLs.settings}/${params.cbidx}/salary`, {
                    params: params
                }
            )
        },
        // @Url /v1/members/current-info
        currentInfo: async(params) => {
            return await http.get(
                `${URLs.members}/current-info`, {
                    params: params
                }
            )
        },
        // @Url /v1/settings/{cbidx}/contract
        contract: async(params) => {
            return await http.get(
                `${URLs.settings}/${params.cbidx}/contract`, {
                    params: params
                }
            )
        },
        // @Url /v1/settings/{cbidx}/contract-service
        contractService: async(params) => {
            return await http.get(
                `${URLs.settings}/${params.cbidx}/contract-service`, {
                    params: params
                }
            )
        },
        // @Url /v1/settings/{cbidx}/steering-committee
        steeringCommittee: async(params) => {
            return await http.get(
                `${URLs.settings}/${params.cbidx}/steering-committee`, {
                    params: params
                }
            )
        },
        // @Url /v1/sync/excel/{cbidx}/result-state
        resultState: async(params) => {
            return await http.get(
                `${URLs.excel}/${params.cbidx}/result-state`, {
                    params: params
                }
            )
        },
        // @Url /v1/sync/excel-down/{cbidx}/recipient-info
        recipientInfoExcelDown: async(params) => {
            return await http.get(
                `/v1/sync/excel-down/${params.cbidx}/recipient-info`, {
                    params: params
                }
            )
        },
        // @Url /v1/sync/excel-down/{cbidx}/staff-contract
        staffContratExcelDown: async(params) => {
            return await http.get(
                `/v1/sync/excel-down/${params.cbidx}/staff-contract`, {
                    params: params
                }
            )
        },
        // @Url /v1/management/{cbidx}/medicine-info
        medicineInfo: async(params) => {
            return await http.get(
                `${URLs.management}/${params.cbidx}/medicine-info`, {
                    params: params
                }
            )
        },
        // @Url /v1/customers/{cbidx}/holiday
        holiday: async(params) => {
            return await http.get(
                `${URLs.customer}/${params.cbidx}/holiday`, {
                    params: params
                }
            )
        },
        // @Url /v1/customers/{cbidx}/vacation-type
        vacationType: async(params) => {
            return await http.get(
                `${URLs.customer}/${params.cbidx}/vacation-type`, {
                    params: params
                }
            )
        },
        // @Url /v1/customers/{cbidx}/vacation-policy
        vacationPolicy: async(params) => {
            return await http.get(
                `${URLs.customer}/${params.cbidx}/vacation-policy`, {
                    params: params
                }
            )
        },
        // @Url /v1/settings/{cbidx}/copayment
        copayment: async(params) => {
            return await http.get(
                `${URLs.settings}/${params.cbidx}/copayment`, {
                    params: params
                }
            )
        },
        // @Url /v1/auth/deduct4insure
        deduct4Insure: async(params) => {
            return await http.get(
                `${URLs.auth}/deduct4insure`, {
                    params: params
                }
            )
        },
        // @Url /v1/auth/salary-number
        salaryNumber: async(params) => {
            return await http.get(
                `${URLs.auth}/salary-number`, {
                    params: params
                }
            )
        },
        // @Url /v1/auth/number-hourly-add
        numberHourly: async(params) => {
            return await http.get(
                `${URLs.auth}/number-hourly-add`, {
                    params: params
                }
            )
        },
        // @Url /v1/auth/standard-salary-add
        standardSalary: async(params) => {
            return await http.get(
                `${URLs.auth}/standard-salary-add`, {
                    params: params
                }
            )
        },
        // @Url /v1/setting/{cbidx}/dash
        dash: async(params) => {
            return await http.get(
                `${URLs.settings}/${params.cbidx}/dash`, {
                    params: params
                }
            )
        },
        // @Url /v1/customers/{cbidx}/extra-title 
        extraTitle: async(params) => {
            return await http.get(
                `${URLs.customer}/${params.cbidx}/extra-title`, {
                    params: params
                }
            )
        },
        // @Url /v1/customers/{cbidx}/deduct-etc-title
        deductEtcTitle: async(params) => {
            return await http.get(
                `${URLs.customer}/${params.cbidx}/deduct-etc-title`, {
                    params: params
                }
            )
        },
        // @Url /v1/payment/{cbidx}/prod-service-fee
        prodServiceFee: async(params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/prod-service-fee`, {
                    params: params
                }
            )
        },
        // @Url /v1/payment/{cbidx}/customer-memo
        customerMemo: async(params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/customer-memo`, {
                    params: params
                }
            )
        },
        // @Url /v1/setting/{cbidx}/salary/minimum-wage
        minimumWage: async(params) => {
            return await http.get(
                `${URLs.settings}/${params.cbidx}/salary/minimum-wage`, {
                    params: params
                }
            )
        },
        // @Url /v1/settings/{cbidx}/salary/used-staffs
        usedPoclicyEmps: async(params) => {
            return await http.get(
                `${URLs.settings}/${params.cbidx}/salary/used-staffs`, {
                    params: params
                }
            )
        }
    },
    post: {
        // @Url /v1/settings/{cbidx}/customer
        customer: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.settings}/${params.cbidx}/customer`, formData,
            )
        },
        // @Url /v1/settings/{cbidx}/logo
        logo: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.settings}/${params.cbidx}/logo`, formData,
            )
        },
        // @Url /v1/settings/{cbidx}/map
        map: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.settings}/${params.cbidx}/map`, formData
            )
        },
        // @Url /v1/settings/{cbidx}/map/{idx}
        mapUpdate: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.settings}/${params.cbidx}/map/${params.idx}`, formData
            )
        },
        // @Url /v1/settings/{cbidx}/base-map/{idx}
        baseMap: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.settings}/${params.cbidx}/base-map/${params.idx}`, formData
            )
        },
        // @Url /v1/customers/office-seal/{cbidx}
        officeSeal: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.customer}/office-seal/${params.cbidx}`, formData,
            )
        },
        // @Url /v1/settings/{cbidx}/car
        car: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.settings}/${params.cbidx}/car`, formData
            )
        },
        // @Url /v1/settings/{cbidx}/car/{idx}
        carUpdate: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.settings}/${params.cbidx}/car/${params.idx}`, formData
            )
        },
        // @Url /v1/settings/{cbidx}/car/{idx}/operation
        operation: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.settings}/${params.cbidx}/car/${params.idx}/operation`, formData
            )
        },
        // @Url /v1/settings/{cbidx}/car/{idx}/operation/{jidx}
        operationUpdate: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.settings}/${params.cbidx}/car/${params.idx}/operation/${params.hidx}`,
                formData
            )
        },
        // @Url /v1/settings/{cbidx}/car/{idx}/maintain
        maintain: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.settings}/${params.cbidx}/car/${params.idx}/maintain`, formData
            )
        },
        // @Url /v1/settings/{cbidx}/car/{idx}/maintain/{midx}
        maintainUpdate: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.settings}/${params.cbidx}/car/${params.idx}/maintain/${params.midx}`,
                formData
            )
        },
        // @Url /v1/settings/{cbidx}/insurance
        insurance: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.settings}/${params.cbidx}/insurance`, formData
            )
        },
        // @Url /v1/staffs/{cbidx}/insurance
        staffInsurance: async(params) => {
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/insurance`,
                params.data, {
                    params: {
                        luidx: params.luidx
                    }
                }
            )
        },
        // @Url /v1/permission/groups/{cbidx}
        groups: async(params) => {
            return await http.post(
                `${URLs.permission}/groups/${params.cbidx}`,
                params.permissionGroup, {
                    params: {
                        luidx: params.luidx,
                        cbidx: params.cbidx
                    }
                }
            )
        },
        // @Url /v1/settings/{cbidx}/contract
        contract: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.settings}/${params.cbidx}/contract`, formData
            )
        },
        // @Url /v1/settings/{cbidx}/contract-service
        contractService: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.settings}/${params.cbidx}/contract-service`, formData
            )
        },
        /**
         * @Url /v1/settings/{cbidx}/salary
         * @deprecated 25.05.01 사용 만료
         * @comment 회사 급여 정책 저장 방식 변경으로 api 새로 생성
         * (before) : salary
         * (after) : companySalaries
         */
        // @Url /v1/settings/{cbidx}/salary
        salary: async(params) => {
            return await http.post(
                `${URLs.settings}/${params.cbidx}/salary`,
                params, {
                    params: {
                        luidx: params.luidx,
                    },
                }
            )
        },
        // @Url /v1/settings/{cbidx}/salary
        companySalaries: async(params) => {
            return await http.post(
                `${URLs.settings}/${params.cbidx}/salary`,
                params.customerSalarySDTO, {
                    params: {
                        luidx: params.luidx,
                        cbidx: params.cbidx
                    }
                }
            )
        },
        // @Url /v1/settings/{cbidx}/steering-committee
        steeringCommittee: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.settings}/${params.cbidx}/steering-committee`, formData
            )
        },
        // // @Url /v1/sync/excel/{cbidx}/async-recipients-file
        // asyncRecipientsFile: async(params) => {
        //     let formData = objectToFormdata(params)
        //     return await http.post(
        //         `${URLs.excel}/${params.cbidx}/async-recipients-file`, formData,
        //     )
        // },
        // // @Url /v1/sync/excel/{cbidx}/async-staffs-file
        // asyncStaffsFile: async(params) => {
        //     let formData = objectToFormdata(params)
        //     return await http.post(
        //         `${URLs.excel}/${params.cbidx}/async-staffs-file`, formData
        //     )
        // },
        // // @Url /v1/sync/excel/{cbidx}/async-longwork-allowance-file
        // asyncLongWorkAllowanceFile: async(params) => {
        //     let formData = objectToFormdata(params)
        //     return await http.post(
        //         `${URLs.excel}/${params.cbidx}/async-longwork-allowance-file`, formData
        //     )
        // },
        // // @Url /v1/sync/excel/{cbidx}/async-claim-detail-file
        // asyncClaimDetailFile: async(params) => {
        //     let formData = objectToFormdata(params)
        //     return await http.post(
        //         `${URLs.excel}/${params.cbidx}/async-claim-detail-file`, formData
        //     )
        // },
        // // @Url /v1/sync/excel/{cbidx}/async-rfids-month-file
        // asyncRfidsMonthFile: async(params) => {
        //     let formData = objectToFormdata(params)
        //     return await http.post(
        //         `${URLs.excel}/${params.cbidx}/async-rfids-month-file`, formData
        //     )
        // },
        // // @Url /v1/sync/excel/{cbidx}/async-plans-month-file
        // asyncPlansMonthFile: async(params) => {
        //     let formData = objectToFormdata(params)
        //     return await http.post(
        //         `${URLs.excel}/${params.cbidx}/async-plans-month-file`, formData
        //     )
        // },
        // // @Url /v1/sync/excel/{cbidx}/async-staff-simple-file
        // asyncStaffSimpleFile: async(params) => {
        //     let formData = objectToFormdata(params)
        //     return await http.post(
        //         `${URLs.excel}/${params.cbidx}/async-staff-simple-file`, formData
        //     )
        // },
        // @Url /v1/sync/excel/{cbidx}/async-recipient-info-file
        asyncRecipientInfoFile: async(params) => {
            let formdata = objectToFormdata(params)
            return await http.post(
                `${URLs.excel}/${params.cbidx}/async-recipient-info-file`, formdata,
            )
        },
        // @Url /v1/sync/excel/{cbidx}/async-staff-contract-file
        asyncStaffContractFile: async(params) => {
            let formdata = objectToFormdata(params)
            return await http.post(
                `${URLs.excel}/${params.cbidx}/async-staff-contract-file`, formdata,
            )
        },
        // @Url /v1/management/{cbidx}/medicine-info
        medicineInfo: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.management}/${params.cbidx}/medicine-info`, formData
            )
        },
        // @Url /v1/customers/{cbidx}/holiday
        holiday: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.customer}/${params.cbidx}/holiday`, formData
            )
        },
        // @Url /v1/customers/{cbidx}/vacation-type
        vacationType: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.customer}/${params.cbidx}/vacation-type`, formData
            )
        },
        // @Url /v1/customers/{cbidx}/vacation-policy
        vacationPolicy: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.customer}/${params.cbidx}/vacation-policy`, formData
            )
        },
        // @Url /v1/settings/{cbidx}/copayment
        copayment: async(params) => {
            return await http.post(
                `${URLs.settings}/${params.cbidx}/copayment`,
                params, {
                    params: {
                        luidx: params.luidx
                    }
                }
            )
        },
        // @Url /v1/customers/{cbidx}/extra-title
        extraTitle: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.customer}/${params.cbidx}/extra-title`,
                formData
            )
        },
        // @Url /v1/customers/{cbidx}/deduct-etc-title
        deductEtcTitle: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.customer}/${params.cbidx}/deduct-etc-title`,
                formData
            )
        },
        // @Url /v1/payment/{cbidx}/customer-memo
        customerMemo: async(params) => {
            // let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.payment}/${params.cbidx}/customer-memo`,
                params, {
                    params: {
                        luidx: params.luidx
                    }
                }
            )
        },
        // @Url /v1/settings/{cbidx}/salary/delete
        salaryPolicies: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.settings}/${params.cbidx}/salary/delete`,
                formData
            )
        },
    },
    delete: {
        // @Url /v1/settings/{cbidx}/logo
        logo: async(params) => {
            return await http.delete(
                `${URLs.settings}/${params.cbidx}/logo`, {
                    params: params
                }
            )
        },
        // @Url /v1/settings/{cbidx}/map/{idx}
        map: async(params) => {
            return await http.delete(
                `${URLs.settings}/${params.cbidx}/map/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/customers/office-seal/{cbidx}
        officeSeal: async(params) => {
            return await http.delete(
                `${URLs.customer}/office-seal/${params.cbidx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/settings/{cbidx}/car/{idx}
        car: async(params) => {
            return await http.delete(
                `${URLs.settings}/${params.cbidx}/car/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/settings/{cbidx}/car/{idx}/operation/{hidx}
        operation: async(params) => {
            return await http.delete(
                `${URLs.settings}/${params.cbidx}/car/${params.idx}/operation/${params.hidx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/settings/{cbidx}/car/{idx}/maintain/{midx}
        maintain: async(params) => {
            return await http.delete(
                `${URLs.settings}/${params.cbidx}/car/${params.idx}/maintain/${params.midx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/permission/groups/{cbidx}/{idx}
        groups: async(params) => {
            return await http.delete(
                `${URLs.permission}/groups/${params.cbidx}/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/management/{cbidx}/medicine-info
        medicineInfo: async(params) => {
            return await http.delete(
                `${URLs.management}/${params.cbidx}/medicine-info`, {
                    params: params
                }
            )
        },
        // @Url /v1/customers/{cbidx}/holiday/{idx}
        holiday: async(params) => {
            return await http.delete(
                `${URLs.customer}/${params.cbidx}/holiday/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/customers/{cbidx}/vacation-type/{idx}
        vacationType: async(params) => {
            return await http.delete(
                `${URLs.customer}/${params.cbidx}/vacation-type/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/settings/{cbidx}/copayment
        copayment: async(params) => {
            return await http.delete(
                `${URLs.settings}/${params.cbidx}/copayment`, {
                    params: params
                }
            )
        },
        // @Url /v1/payment/{cbidx}/customer-memo/{idx}
        customerMemo: async(params) => {
            return await http.delete(
                `${URLs.payment}/${params.cbidx}/customer-memo/${params.idx}`, {
                    params: params
                }
            )
        },
    }
}


// WEBPACK FOOTER //
// ./src/api/services.js